const projectSettingsPath = '/project-settings';
const workspaceProjectSettingsPath = '/workspaces';
export const missingProjectRedirectPath = '/execution-runs';
export const missingProjectRedirectMessage = 'Redirecting to execution runs...';
export const projectCsvMappingAnchorId = 'xlsx-csv-mapping';
export const projectExecutionRunThresholdsAnchorId = 'execution-run-metric-thresholds';
const csvMappingHash = `#${projectCsvMappingAnchorId}`;
const executionRunThresholdsHash = `#${projectExecutionRunThresholdsAnchorId}`;
const projectIdParam = 'projectId';

export const buildProjectSettingsHref = (projectId: string): string => {
  const searchParams = new URLSearchParams({ [projectIdParam]: projectId });
  return `${projectSettingsPath}?${searchParams.toString()}`;
};

export const buildWorkspaceProjectSettingsHref = ({
  workspaceSlug,
  projectSlug,
}: {
  workspaceSlug: string;
  projectSlug: string;
}): string =>
  `${workspaceProjectSettingsPath}/${encodeURIComponent(workspaceSlug)}/projects/${encodeURIComponent(
    projectSlug,
  )}/settings`;

export const buildProjectSettingsHrefForProject = ({
  projectId,
  projectSlug,
  workspaceSlug,
}: {
  projectId: string;
  projectSlug: string;
  workspaceSlug?: string | null;
}): string =>
  workspaceSlug
    ? buildWorkspaceProjectSettingsHref({ workspaceSlug, projectSlug })
    : buildProjectSettingsHref(projectId);

export const buildProjectCsvMappingSettingsHref = (projectId: string): string => {
  return `${buildProjectSettingsHref(projectId)}${csvMappingHash}`;
};

export const buildProjectCsvMappingSettingsHrefForProject = (input: {
  projectId: string;
  projectSlug: string;
  workspaceSlug?: string | null;
}): string => `${buildProjectSettingsHrefForProject(input)}${csvMappingHash}`;

export const buildProjectExecutionRunThresholdsSettingsHref = (projectId: string): string => {
  return `${buildProjectSettingsHref(projectId)}${executionRunThresholdsHash}`;
};

export const resolveProjectSettingsProjectId = (search: string): string | null => {
  const searchParams = new URLSearchParams(search);
  const projectId = searchParams.get(projectIdParam)?.trim() ?? '';
  return projectId.length > 0 ? projectId : null;
};

export const resolveProjectSettingsTabFromHash = (hash: string): 'test' | 'operations' | null => {
  if (hash === `#${projectCsvMappingAnchorId}`) {
    return 'test';
  }
  if (hash === `#${projectExecutionRunThresholdsAnchorId}`) {
    return 'test';
  }
  return null;
};
